import React from 'react'
import './Box.css'
import ContainerBackground from '../ContainerBackground/ContainerBackground'
import Navbar from '../Navbar/Navbar'
import {useTheme} from '../ThemeContext/ThemeContext';
import PanicButton from '../PanicButton/PanicButton';
import ThemeMenuButton from '../ThemeMenuButton/ThemeMenuButton';


function Box({ children }) {
    const { currentTheme, switchTheme } = useTheme();

  return (
    <div>
        <ContainerBackground theme={currentTheme}>
        <Navbar/>
        <div className='boxContainer'>
        
        <div className = 'pinkCard'>
            <div className = 'blueCard'>
            {children}
            </div>
        </div>
        </div>
        <ThemeMenuButton/>
        <PanicButton />
        </ContainerBackground>
    </div>
  );
};

export default Box

